import { defineComponent as _defineComponent } from 'vue'
import { now } from '@/utils/datetime';
import { PropType, reactive, ref } from 'vue';
import { SdsSection9FlashPoint } from '@/interfaces/model/general/sds';
import { NewSdsSection9FlashPoint } from '@/lib/constructor/model/general/sds';
import { TEMPERATURE_MINIMUM, TEMPERATURE_MAXIMUM } from '@/lib/constant';
import SdsSection9FlashPointForm from '@/views/dashboard/sdsDrawer/forms/SdsSection9FlashPointForm.vue';
import { TemperatureUnitId } from '@/lib/enum';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTableSection9FlashPoint',
  props: {
  isEditing: {
    type: Boolean,
    default: false,
  },
  flashPointList: {
    type: Array as PropType<Array<SdsSection9FlashPoint>>,
    required: true,
    default: () => [],
  },
},
  emits: ["update:isValid", "update:flashPointList"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:flashPointList', data: Array<SdsSection9FlashPoint>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  createFlashPoint: '引火点のデータを作成してください',
  flashPoint: '引火点',
});



const headerSection9 = [
  { text: $t(m.flashPoint), value: 'flashPoint', sortable: false },
  {
    text: $t(sharedMessages.measurementMethod),
    value: 'flashPointMeasurement',
    sortable: false,
  },
  { text: '', value: 'action', sortable: false },
];

const isValidNewFlashPoint = ref<boolean>(false);
const isValidUpdatedFlashPoint = ref<boolean>(false);
const expanded = ref<Array<number>>([0]);

const newFlashPoint = reactive<SdsSection9FlashPoint>(
  structuredClone(NewSdsSection9FlashPoint)
);
const updatedFlashPoint = reactive<SdsSection9FlashPoint>(
  structuredClone(NewSdsSection9FlashPoint)
);

const flashPointIndex = ref<number>(0);

const modalDeleteFlashPoint = ref<boolean>(false);
const modalRescueFlashPoint = ref<boolean>(false);
const modalEditFlashPoint = ref<boolean>(false);
const modalNewFlashPoint = ref<boolean>(false);

const openNewFlashPointModal = (): void => {
  modalNewFlashPoint.value = true;
};

const closeNewFlashPointModal = (): void => {
  modalNewFlashPoint.value = false;
};

const openDeleteFlashPointModal = (): void => {
  modalDeleteFlashPoint.value = true;
};

const closeDeleteFlashPointModal = (): void => {
  modalDeleteFlashPoint.value = false;
};

const openRescueFlashPointModal = (): void => {
  modalRescueFlashPoint.value = true;
};

const closeRescueFlashPointModal = (): void => {
  modalRescueFlashPoint.value = false;
};

const openEditFlashPointModal = (): void => {
  modalEditFlashPoint.value = true;
};

const closeEditFlashPointModal = (): void => {
  modalEditFlashPoint.value = false;
};



const bindFlashPoint = () => {
  updatedFlashPoint.id = props.flashPointList[flashPointIndex.value].id;
  updatedFlashPoint.sds_id = props.flashPointList[flashPointIndex.value].sds_id;
  updatedFlashPoint.sds_product_id =
    props.flashPointList[flashPointIndex.value].sds_product_id;
  updatedFlashPoint.flash_point_min =
    props.flashPointList[flashPointIndex.value].flash_point_min;
  updatedFlashPoint.flash_point_max =
    props.flashPointList[flashPointIndex.value].flash_point_max;
  updatedFlashPoint.flash_point_inequality_sign =
    props.flashPointList[flashPointIndex.value].flash_point_inequality_sign;
  updatedFlashPoint.unit_id =
    props.flashPointList[flashPointIndex.value].unit_id;
  updatedFlashPoint.measurement_method =
    props.flashPointList[flashPointIndex.value].measurement_method;
};

const clearNewForm = () => {
  newFlashPoint.flash_point_inequality_sign = 1;
  newFlashPoint.flash_point_min = 0;
  newFlashPoint.flash_point_max = 0;
  newFlashPoint.unit_id = TemperatureUnitId.CELSIUS.value;
  newFlashPoint.measurement_method = '';
};

const addFlashPoint = () => {
  switch (newFlashPoint.flash_point_inequality_sign) {
    case 0:
      newFlashPoint.flash_point_min = TEMPERATURE_MINIMUM;
      newFlashPoint.flash_point_max = TEMPERATURE_MAXIMUM;
      break;
    case 1:
      newFlashPoint.flash_point_max = newFlashPoint.flash_point_min;
      break;
    case 2:
      newFlashPoint.flash_point_max = TEMPERATURE_MAXIMUM;
      break;
    case 3:
      newFlashPoint.flash_point_max = TEMPERATURE_MAXIMUM;
      break;
    case 4:
      newFlashPoint.flash_point_min = TEMPERATURE_MINIMUM;
      break;
    case 5:
      newFlashPoint.flash_point_min = TEMPERATURE_MINIMUM;
      break;
    case 6:
      break;
    case 7:
      break;
    case 8:
      break;
    case 9:
      break;
    default:
      break;
  }
  const data: Array<SdsSection9FlashPoint> = [...props.flashPointList];
  data.push(structuredClone(newFlashPoint));

  emits('update:flashPointList', data);
};

const editFlashPoint = () => {
  switch (updatedFlashPoint.flash_point_inequality_sign) {
    case 0:
      updatedFlashPoint.flash_point_min = TEMPERATURE_MINIMUM;
      updatedFlashPoint.flash_point_max = TEMPERATURE_MAXIMUM;
      break;
    case 1:
      updatedFlashPoint.flash_point_max = updatedFlashPoint.flash_point_min;
      break;
    case 2:
      updatedFlashPoint.flash_point_max = TEMPERATURE_MAXIMUM;
      break;
    case 3:
      updatedFlashPoint.flash_point_max = TEMPERATURE_MAXIMUM;
      break;
    case 4:
      updatedFlashPoint.flash_point_min = TEMPERATURE_MINIMUM;
      break;
    case 5:
      updatedFlashPoint.flash_point_min = TEMPERATURE_MINIMUM;
      break;
    case 6:
      break;
    case 7:
      break;
    case 8:
      break;
    case 9:
      break;
    default:
      break;
  }
  const data: Array<SdsSection9FlashPoint> = [...props.flashPointList];
  data[flashPointIndex.value] = structuredClone(updatedFlashPoint);

  emits('update:flashPointList', data);
};

const deleteFlashPoint = (): void => {
  const data: Array<SdsSection9FlashPoint> = [...props.flashPointList];
  data[flashPointIndex.value].deleted_at = now().toString();

  emits('update:flashPointList', data);
};

const rescueFlashPoint = (): void => {
  const data: Array<SdsSection9FlashPoint> = [...props.flashPointList];
  data[flashPointIndex.value].deleted_at = null;

  emits('update:flashPointList', data);
};

const parseFlashPoint = (fp: SdsSection9FlashPoint): string => {
  let parsedFlashPoint = '';
  const unit = TemperatureUnitId.fromId(fp.unit_id).text;

  switch (fp.flash_point_inequality_sign) {
    case 1:
      parsedFlashPoint = $t(sharedMessages.valuesEqual, {
        value: fp.flash_point_min,
        unit,
      });
      break;
    case 2:
      parsedFlashPoint = $t(sharedMessages.valuesGreaterThanOrEqual, {
        value: fp.flash_point_min,
        unit,
      });
      break;
    case 3:
      parsedFlashPoint = $t(sharedMessages.valuesGreaterThan, {
        value: fp.flash_point_min,
        unit,
      });
      break;
    case 4:
      parsedFlashPoint = $t(sharedMessages.valuesLessThanOrEqual, {
        value: fp.flash_point_max,
        unit,
      });
      break;
    case 5:
      parsedFlashPoint = $t(sharedMessages.valuesLessThan, {
        value: fp.flash_point_max,
        unit,
      });
      break;
    case 6:
      parsedFlashPoint = $t(sharedMessages.valuesBetweenInclusive, {
        minValue: fp.flash_point_min,
        maxValue: fp.flash_point_max,
        unit,
      });
      break;
    case 7:
      parsedFlashPoint = $t(sharedMessages.valuesBetweenExclusiveInclusive, {
        minValue: fp.flash_point_min,
        maxValue: fp.flash_point_max,
        unit,
      });
      break;
    case 8:
      parsedFlashPoint = $t(sharedMessages.valuesBetweenExclusive, {
        minValue: fp.flash_point_min,
        maxValue: fp.flash_point_max,
        unit,
      });
      break;
    case 9:
      parsedFlashPoint = $t(sharedMessages.valuesBetweenExclusiveExclusive, {
        minValue: fp.flash_point_min,
        maxValue: fp.flash_point_max,
        unit,
      });
      break;
    default:
      parsedFlashPoint = ''; // Handle invalid or missing condition
      break;
  }

  return parsedFlashPoint;
};

return { __sfc: true,$t, m, props, headerSection9, isValidNewFlashPoint, isValidUpdatedFlashPoint, expanded, newFlashPoint, updatedFlashPoint, flashPointIndex, modalDeleteFlashPoint, modalRescueFlashPoint, modalEditFlashPoint, modalNewFlashPoint, openNewFlashPointModal, closeNewFlashPointModal, openDeleteFlashPointModal, closeDeleteFlashPointModal, openRescueFlashPointModal, closeRescueFlashPointModal, openEditFlashPointModal, closeEditFlashPointModal, emits, bindFlashPoint, clearNewForm, addFlashPoint, editFlashPoint, deleteFlashPoint, rescueFlashPoint, parseFlashPoint, SdsSection9FlashPointForm, sharedMessages }
}

})